const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/task-assignment/$requestId.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/task-assignment/$requestId.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { TaskRequestDetailSkeleton } from '@/features/task-assignment/components/TaskRequestDetailSkeleton';
import { taskRequestDetailQuery } from '@/features/task-assignment/services/taskAssignmentQueries';
import { taskAssignmentSearchSchema } from '@/features/task-assignment/types/taskAssignment';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/supervisor/task-assignment/$requestId')({
  validateSearch: taskAssignmentSearchSchema,
  loader: ({
    context,
    params
  }) => context.queryClient.ensureQueryData(taskRequestDetailQuery(params.requestId)),
  pendingComponent: TaskRequestDetailSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});